const codeQueryKeys = {
  fromUrl: (url) => [
    "code-url",
    url
  ],
  fromHash: (hash) => [
    "code-hash",
    hash
  ]
};

export { codeQueryKeys };
//# sourceMappingURL=codeQueryKeys.js.map
